module.exports = __webpack_public_path__ + "media/images/fundraise/fundraise-img-05-3d8cdc4a32a56ddc1806b45fc10e97bb.jpg";